<div class="d-flex flex-column alig-items-center">
  <div
    *ngIf="loginCustomization"
    class="login-welcome mx-auto"
  >
    <h6
      class="text-center text-white mt-3 mb-4"
      [innerHTML]="(loginCustomization.loginPageMessage || environment.customization.loginPageMessage) | nl2br"
    >{{'message.logWordlLeadingM2M' | translate}}</h6>
  </div>
  <div class="login-form mx-auto">
    <h3>{{ 'label.signIn' | translate }}</h3>
    <form
      #loginForm="ngForm"
      (ngSubmit)="login(loginForm)"
      novalidate
    >
      <div
        class="mb-3"
        [podValidationClass]="username"
      >
        <label
          for="username"
          class="form-label"
        >{{'label.emailOrUsername' | translate}}</label>
        <input
          type="text"
          class="form-control"
          id="username"
          name="username"
          [(ngModel)]="model.username"
          #username="ngModel"
          placeholder="{{'label.emailOrUsername' | translate}}"
          required
          minlength="4"
        />
        <pod-validation-messages
          [model]="username"
          fieldName="{{'label.emailOrUsername' | translate}}"
        ></pod-validation-messages>
      </div>
      <div
        class="mb-3"
        [podValidationClass]="password"
      >
        <label
          for="password"
          class="form-label"
        >{{'label.password' | translate}}</label>
        <input
          type="password"
          class="form-control"
          id="password"
          name="password"
          [(ngModel)]="model.password"
          #password="ngModel"
          placeholder="{{'label.password' | translate}}"
          required
        />
        <pod-validation-messages
          [model]="password"
          fieldName="{{'label.password' | translate}}"
        ></pod-validation-messages>
        <p class="form-text text-end"><small><a
              routerLink="reset-password"
              id="login-reset-password"
            >{{'message.forgotPassword' | translate}}</a></small></p>
      </div>
      <p
        *ngIf="error"
        class="alert alert-danger"
      >{{error}}</p>
      <div class="d-grid">
        <button
          type="submit"
          class="btn btn-tertiary"
          [disabled]="submitting"
          id="login-submit"
        >
          {{ submitting ? ('label.login...' | translate) : ('label.login' | translate)}}
        </button>
      </div>
    </form>
  </div>
</div>
